export default {
  SET_SCHOOLS: 'setSchools',
  SET_SCHOOL_TYPES: 'setSchoolTypes',
  SET_MUNICIPALITIES: 'setMunicipalities',
  SET_RLVTYPES: 'setRLVClassificationTypes',
  SET_SCHOOL_INFORMATION: 'setSchoolInformation',
  SET_RESULTS: 'setResults',
  SET_FILTER: 'setFilter',
  SET_PAGINATION: 'setPagination',
  CLEAN_SCHOOL: 'cleanSchool',
};
